const API_VERSION = '1.0.0';

const {REACT_APP_BASE_URL, REACT_APP_IMAGE_URL} = process.env;

const API_URL = `${REACT_APP_BASE_URL}/api/v/${API_VERSION}`;

export const PUBLIC_API_URL = `${API_URL}/public`;
export const SECURED_API_URL = `${API_URL}/secured`;

export const FILE_SERVER = `${REACT_APP_IMAGE_URL}/api/v/${API_VERSION}/secured`;

export const IMAGE_UPLOAD_URL = `${FILE_SERVER}/aws/upload/image`;
export const PROFILE_IMAGE_UPLOAD_URL = `${FILE_SERVER}/aws/profile-pic/update`;
export const RETRIEVE_IMAGE_URL = `${PUBLIC_API_URL}/aws/get/files`;

//auth
export const USER_SIGNIN_URL = `${PUBLIC_API_URL}/users/login`;
export const RESTAURANT_OWNER_SIGNUP_URL = `${PUBLIC_API_URL}/restaurant-owner/sign-up`;
export const OTP_VERIFY_URL = `${PUBLIC_API_URL}/users/verify/email-verification`;
export const RESET_PASSWORD = `${PUBLIC_API_URL}/users/request/reset-password-by-email`;
export const RESET_PASSWORD_OTP_VERIFY = `${PUBLIC_API_URL}/users/verify/email-verification`;
export const RESEND_OTP_URL = `${PUBLIC_API_URL}/users/resend-otp`;

//role
export const GET_ROLE_LIST = `${SECURED_API_URL}/roles`;
export const GET_ROLE_BY_ID = `${SECURED_API_URL}/roles/id`;
export const POST_ROLE_URL = `${SECURED_API_URL}/roles/create`;
export const UPDATE_ROLE_URL = `${SECURED_API_URL}/roles/update`;
export const ALL_PERMISSION_URL = `${SECURED_API_URL}/roles/permissions`;

//user
export const GET_PROFILE = `${SECURED_API_URL}/users/profile`;
export const GET_USER_LIST = `${SECURED_API_URL}/users`;
export const ADD_USER = `${SECURED_API_URL}/users/create`;
export const GET_USER_BY_ID = `${SECURED_API_URL}/users/id`;
export const UPDATE_USER_BY_ID = `${SECURED_API_URL}/users/update`;
export const UPDATE_USER_PROFILE = `${SECURED_API_URL}/users/profile/update`;
export const CHANGE_PASSWORD = `${SECURED_API_URL}/users/change-password`;

//restaurant owner
export const GET_ALL_RESTAURANT_OWNER = `${SECURED_API_URL}/users/get-all/restaurant-owner`

//restaurant
export const GET_ALL_RESTAURANT = `${SECURED_API_URL}/restaurants`;
// export const GET_ALL_RESTAURANT = `${SECURED_API_URL}/users/get-all/restaurant-owner`;
export const GET_RESTAURANT_BY_ID = `${SECURED_API_URL}/restaurants/id`;
export const ADD_RESTAURANT = `${SECURED_API_URL}/users/create/restaurant-owner`;
export const EDIT_RESTAURANT = `${SECURED_API_URL}/restaurants/update`;

//personal restaurant
export const GET_ALL_PERSONAL_RESTAURANT = `${SECURED_API_URL}/restaurants/personal`;
export const GET_PERSONAL_RESTAURANT_BY_ID = `${SECURED_API_URL}/restaurants/personal/id`;
export const EDIT_PERSONAL_RESTAURANT = `${SECURED_API_URL}/restaurants/update/personal`;

//restaurant profile
export const EDIT_RESTAURANT_PROFILE = `${SECURED_API_URL}/users/update/restaurant-owner-profile`;
export const GET_RESTAURANT_PROFILE = `${SECURED_API_URL}/users/restaurant-owner/profile`;

//table layout
export const GET_TABLE_LAYOUT_LIST = `${SECURED_API_URL}/table-layouts`;
export const GET_TABLE_LAYOUT_LIST_BY_OWNER = `${SECURED_API_URL}/table-layouts/owner`;
export const ADD_TABLE_LAYOUT = `${SECURED_API_URL}/table-layouts/create`;
export const GET_TABLE_LAYOUT_BY_ID = `${SECURED_API_URL}/table-layouts/id`;
export const DELETE_TABLE_LAYOUT = `${SECURED_API_URL}/table-layouts/delete`;
export const EDIT_TABLE_LAYOUT = `${SECURED_API_URL}/table-layouts/update`;

//floor layout
export const ADD_FLOOR = `${SECURED_API_URL}/floors/create`;
export const GET_FLOOR_LIST = `${SECURED_API_URL}/floors`;
export const EDIT_FLOOR = `${SECURED_API_URL}/floors/update`;

//floor type
export const GET_FLOOR_TYPE_LIST = `${PUBLIC_API_URL}/floor/types`;

//schedule
export const GET_SCHEDULE_LIST = `${SECURED_API_URL}/schedules`;
export const ADD_SCHEDULE = `${SECURED_API_URL}/schedules/create`;
export const GET_SCHEDULE_BY_ID = `${SECURED_API_URL}/schedules/id`;
export const EDIT_SCHEDULE = `${SECURED_API_URL}/schedules/update`;
export const DELETE_SCHEDULE = `${SECURED_API_URL}/schedules/delete`;

//special off day
export const GET_SPECIAL_OFF_DAY_LIST = `${SECURED_API_URL}/special-off-days`;
export const GET_SPECIAL_OFF_DAY_BY_ID = `${SECURED_API_URL}/special-off-days/id`;
export const ADD_SPECIAL_OFF_DAY = `${SECURED_API_URL}/special-off-days/create`;
export const EDIT_SPECIAL_OFF_DAY = `${SECURED_API_URL}/special-off-days/update`;

export const GET_SCHEDULE_TIME = `${PUBLIC_API_URL}/schedule/time`;

//schedule shift
export const GET_SCHEDULE_SHIFT = `${PUBLIC_API_URL}/schedule/shift`;

//restaurant config
export const GET_RESTAURANT_CONFIG_LIST = `${SECURED_API_URL}/restaurant-configs`;
export const ADD_RESTAURANT_CONFIG = `${SECURED_API_URL}/restaurant-configs/create`;
export const GET_RESTAURANT_CONFIG_BY_ID = `${SECURED_API_URL}/restaurant-configs/id`;
export const GET_ACTIVE_RESTAURANT_CONFIG_BY_ID = `${SECURED_API_URL}/restaurant-configs/active`;
export const EDIT_RESTAURANT_CONFIG = `${SECURED_API_URL}/restaurant-configs/update`;

//token config
export const GENERATE_RESTAURANT_TOKEN = `${SECURED_API_URL}/restaurant-configs/generate-token`;
export const GET_RESTAURANT_TOKEN = `${SECURED_API_URL}/restaurant-configs/get-token`;

//reserve
export const GET_RESERVE_LIST = `${SECURED_API_URL}/bookings`;
export const GET_RESERVED_FLOOR_TABLES_RESERVED_ID = `${SECURED_API_URL}/bookings/personal/reserved/floor-table/by-booking`;
export const GET_RESERVE_BY_ID = `${SECURED_API_URL}/bookings`;
export const GET_RESERVE_STATES_BY_RESERVE_ID = `${SECURED_API_URL}/booking-states/get-all/by-booking-id`;
export const UPDATE_RESERVE = `${SECURED_API_URL}/bookings/update`;
export const UPDATE_RESERVE_STATUS = `${SECURED_API_URL}/booking-states/update`;
export const CREATE_RESERVE = `${SECURED_API_URL}/bookings/create`;
export const GET_RESERVE_CSV_DATA = `${SECURED_API_URL}/bookings/csv-data`;

//dashboard
export const GET_DASHBOARD_COUNT = `${SECURED_API_URL}/dashboard/count`;
export const GET_DASHBOARD_GRAPH_DATA = `${SECURED_API_URL}/dashboard/registration/graph`;
export const GET_RESTAURANT_DASHBOARD_COUNT = `${SECURED_API_URL}/dashboard/owner/count`;
export const GET_RESTAURANT_DASHBOARD_GRAPH_DATA = `${SECURED_API_URL}/dashboard/owner/bookings/graph`;

//image upload folder
export const TABLE_LAYOUT_FOLDER = "table-layout";
export const RESTAURANT_FOLDER = "restaurant";
export const PROFILE_PICTURE = "profile-picture";

// Token & Profile
export const ACCESS_TOKEN = 'tm-token-frontend';
export const PROFILE = "tm-profile-frontend";

// Currency
export const BD_TK_SIGN = "৳ ";

// Gender

export const GENDER_COLOR = {
    MALE: "blue",
    FEMALE: "green",
    OTHERS: "purple"
}

export const RESERVE_STATUS_COLOR = {
    CONFIRMED: "#108ee9",
    SEATED: "#2db7f5",
    WAITING: "#ffc107",
    COMPLETED: "#87d068",
    CANCELED: "#D62200",
}

export const RESERVE_STATUS = {
    SEATED: "SEATED",
    WAITING: "WAITING",
    COMPLETED: "COMPLETED",
    CANCELED: "CANCELED",
}
